import { createAction } from 'typesafe-actions';

export enum LOADING {
  START_LOADING = 'loading/START_LOADING',
  FINISH_LOADING = 'loading/FINISH_LOADING',
}

export const startLoading = createAction(LOADING.START_LOADING)<string>();
export const finishLoading = createAction(LOADING.FINISH_LOADING)<string>();
